import { Box } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import PageHeader from "../../../../../components/PageHeader";
import { secondAxios } from "../../../../../api/axios";
import TaskList from "./TaskList";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

const PlantTaskPage = () => {
  // One client for the page's lifetime - created per render it would drop
  // the task cache every time the page re-rendered.
  const [queryClient] = useState(() => new QueryClient());
  const [plant, setPlant] = useState(null);
  const { plantId } = useParams();

  useEffect(() => {
    const getPlant = async () => {
      try {
        const response = await secondAxios.get(`/plant/${plantId}`);
        setPlant(response.data);
      } catch (err) {
        console.error("Error fetching plant:", err);
      }
    };
    getPlant();
  }, [plantId]);

  return (
    <QueryClientProvider client={queryClient}>
      <Box
        sx={{
          width: "100%",
          maxWidth: "100%",
          position: "relative",
          bgcolor: "background.default",
          minHeight: "85vh",
        }}
      >
        <PageHeader
          plant={plant ?? { id: plantId }}
          pageTitle="Action Items"
          moduleKey="task"
        />
        <Box sx={{ p: { xs: 2, md: 3 } }}>
          {plant && <TaskList selectedPlant={plant} />}
        </Box>
      </Box>
    </QueryClientProvider>
  );
};

export default PlantTaskPage;
